import type { Project } from './types';

export const buildProjectURL = (project: Project): string =>
	`/plugins/servlet/project-config/${project.key}/summary`;
